import React from 'react';

import { PastEpisodesData } from '~/stores/use-chat/use-chat.types';

import { InsightPastEpisodes } from './components/insight-past-episodes/InsightPastEpisodes';
import { ScenarioPastEpisodes } from './components/scenario-past-episodes/ScenarioPastEpisodes';

export const PastEpisodesWidget = (data: PastEpisodesData) => {
  if (data.variant === 'insight-past-episodes') {
    return <InsightPastEpisodes {...data} />;
  }

  return <ScenarioPastEpisodes {...data} />;
};
